<h2 mat-dialog-title>Nouveau décorticage</h2>
<mat-dialog-content class="mat-typography">
    <mat-form-field>
        <input matInput placeholder="Selectionner code chantier" autocomplete="off" matInput #input
            (blur)="verifierCodeChantier($event.target.value.toUpperCase())"
            (keyup.enter)="verifierCodeChantier($event.target.value.toUpperCase())"
            (input)="input.value=$event.target.value.toUpperCase()">
    </mat-form-field>
    Ou
    <span>
        <span *ngIf="!mChargerLaListeDesChantier; else elseBlock">
            <button mat-raised-button (click)="chargerListDecorticage()">rechercher dans la list</button>
        </span>
        <ng-template #elseBlock>
            <mat-form-field>
                <mat-label>Selectionner décorticage</mat-label>
                <mat-select [(ngModel)]="CodeDecorticageSelectionner" name="codeDec">
                    <mat-option *ngFor="let decorticage of ListDecorticage" [value]="decorticage.CODEDECORTICAGE">
                        {{decorticage.CODEDECORTICAGE}}</mat-option>
                </mat-select>
            </mat-form-field>
        </ng-template>
    </span>

    <h4>Code Deco: <input matInput placeholder="Selectionner code chantier" [disabled]="true" autocomplete="off"
            matInput [(ngModel)]="mCodeDecorticageAttribue"></h4>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <div [hidden]="!mBoolCreationDuDecoEnCours">
        <mat-spinner></mat-spinner>
    </div>
    <button mat-raised-button [disabled]="!mCodeDecorticageAttribue" (click)="validerDecorticage()">
        Créer decorticage {{ mCodeDecorticageAttribue }}
    </button>
    <button mat-raised-button mat-dialog-close>Annuler</button>
</mat-dialog-actions>